// @mui
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
//
import Iconify from 'src/components/iconify';

// ----------------------------------------------------------------------

type Props = {
  title: string;
  body: string;
  onSkip: () => void;
};

export default function SkipCard({ title, body, onSkip }: Props) {
  return (
    <Card variant="outlined" sx={{ p: 2.5, bgcolor: '#FAFCFA' }}>
      <Stack
        direction={{ xs: 'column', sm: 'row' }}
        spacing={2}
        alignItems={{ sm: 'center' }}
        justifyContent="space-between"
      >
        <Stack spacing={0.5}>
          <Typography variant="subtitle2">{title}</Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            {body}
          </Typography>
        </Stack>
        <Button
          variant="outlined"
          color="inherit"
          endIcon={<Iconify icon="eva:arrow-ios-forward-fill" width={16} />}
          onClick={onSkip}
          sx={{ flexShrink: 0 }}
          data-testid="skip-step"
        >
          Skip for now
        </Button>
      </Stack>
    </Card>
  );
}
